import api from "./api";

export const getAllEmployees = async () => {
  const response = await api.get(`/api/personal-info/status?status=WAITING_FOR_SALARY_INITIATE`);
  return response.data;
}

export const salaryPost = async (employeeUniqueId, payload) => {
  const response = await api.post(`/api/salary-structure/${employeeUniqueId}`, payload);
  return response;
}


export const getPfNotRegisterdEmployees = async (stateId, districtId) => {
  try {

    let url = `/api/employee-pf/pfregisterreport?stateId=${stateId}`;
    if (districtId) {
      url += `&districtId=${districtId}`;
    }

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching PF not registered employees:", error);
    throw error;
  }
};


export const getBasicEmployeeReport = async (params) => {
  try {
    const response = await api.get(`/api/personal-info/basic`, { params });
    return response;
  } catch (error) {
    console.error("Error fetching salary structure report:", error);
    throw error; // rethrow so component can handle it
  }
};

export const getEsicMonthlyReport = async (month, year,) => {
  try {
    let url = `/api/employees/esic/earnings?month=${month}&year=${year}`;

    // if (districtId) {
    //   url += `&districtId=${districtId}`;
    // }

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching ESI Monthly Report:", error);
    throw error;
  }
};


export const getBankStatementReport = async (params) => {
  try {
    const response = await api.get(`/api/salary-structure/bank`, { params });
    return response;
  } catch (error) {
    console.error("Error fetching salary structure report:", error);
    throw error; // rethrow so component can handle it
  }
};

//http://localhost:8080/api/employee-pf/nopfesi?stateId=3&clientId=1&projectId=1&districtId=1
export const getEPFAndUANAndMemberIDnotavabilbeEmployees = async (stateId, clientId, projectId, districtId) => {
  try {

    let url = `/api/employee-pf/nopfesi?stateId=${stateId}`;
    if (clientId) {
      url += `&clientId=${clientId}`

    }
    if (projectId) {
      url += `&projectId=${projectId}`
    }
    if (districtId) {
      url += `&districtId=${districtId}`;
    }

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching PF not registered employees:", error);
    throw error;
  }
};
export const getEmployeeUpdationForEmailAndMobile = async (stateId, clientId, projectId, districtId) => {
  try {

    let url = `/api/employee-posting/update-personal-info?stateId=${stateId}`;
    if (clientId) {
      url += `&clientId=${clientId}`

    }
    if (projectId) {
      url += `&projectId=${projectId}`
    }
    if (districtId) {
      url += `&districtId=${districtId}`;
    }

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching PF not registered employees:", error);
    throw error;
  }
};
export const esicUanUpdate = async ({ updates: submissionData }) => {

  const response = await api.put(`api/employee-pf/bulk`, { updates: submissionData }, {
    headers: { "Content-Type": "application/json" }
  });
  return response.data;


}
export const emailMobileUpdate = async (submissionData) => {
  const response = await api.patch(
    'api/personal-info/bulk-update',  // or /api/personal-info/bulk-update
    submissionData,  // ← Send the array directly
    {
      headers: { "Content-Type": "application/json" }
    }
  );
  return response.data;
};

